'use strict';

var selectFromObject = require('./selectFromObject');

function objectReject(obj, f) {
  return selectFromObject(obj, f, false);
}

module.exports = objectReject;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/internal/objectReject.js
// module id = 795
// module chunks = 0